export default viewComponent => () => import(`@/views/${viewComponent}`);
